/* The Nearside Saddlery & Outfitters — Shopify theme behaviour. Plain vanilla,
   no dependencies. Same interactions as the approved design: mega menu, mobile
   drawer, header search, hero slider, product-row carousels, media gallery +
   lightbox, variant picker, quantity stepper, cart drawer + cart page (Shopify's
   /cart/*.js AJAX API), pickup drawer, store locator, collection filter/sort,
   newsletter + contact confirmation.

   Offline (the port's static preview) the /cart/*.js endpoints are not there, so
   the cart falls back to a local cart — the drawer and cart page still work so
   the port can be driven and looked at before it is pushed to a store. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var open = function (el, on) { if (!el) return; if (on) el.setAttribute('data-open', ''); else el.removeAttribute('data-open'); };
  var isOpen = function (el) { return !!el && el.hasAttribute('data-open'); };
  var escH = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
  var money = function (c) { return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' AUD'; };
  var ROUTES = window.NS_ROUTES || {};
  var STRINGS = window.NS_STRINGS || {};
  var t = function (k, fallback) { return STRINGS[k] != null ? STRINGS[k] : fallback; };
  var url = function (name, fallback) { return ROUTES[name] || fallback; };

  /* ------------------------------------------------ inert links */
  $$('a[aria-disabled="true"]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); });
  });

  /* ------------------------------------------------ scrim */
  var scrim = $('.scrim');
  function closeAllOverlays() {
    open($('.mdrawer'), false); open($('.cart'), false); open($('.pdrawer'), false);
    open(scrim, false); document.body.style.overflow = '';
    $$('.mega__top[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    $$('.mega__panel[data-open]').forEach(function (p) { open(p, false); });
  }
  function showOverlay(el) {
    closeAllOverlays(); open(el, true); open(scrim, true); document.body.style.overflow = 'hidden';
    var f = el.querySelector('button, a, input'); if (f) f.focus();
  }
  if (scrim) scrim.addEventListener('click', closeAllOverlays);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (isOpen($('.modal'))) { open($('.modal'), false); document.body.style.overflow = ''; return; }
    if (isOpen($('.locator'))) { open($('.locator'), false); return; }
    closeAllOverlays();
  });
  $$('[data-close]').forEach(function (b) {
    b.addEventListener('click', function () { closeAllOverlays(); });
  });

  /* ------------------------------------------------ mega menu */
  $$('.mega__top[data-panel]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('data-panel'));
    if (!panel) return;
    var show = function (on) {
      $$('.mega__panel[data-open]').forEach(function (p) { if (p !== panel) open(p, false); });
      $$('.mega__top[aria-expanded="true"]').forEach(function (b) { if (b !== btn) b.setAttribute('aria-expanded', 'false'); });
      open(panel, on); btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    };
    btn.addEventListener('click', function (e) { e.preventDefault(); show(btn.getAttribute('aria-expanded') !== 'true'); });
    btn.addEventListener('mouseenter', function () { show(true); });
    btn.addEventListener('focus', function () { show(true); });
    panel.addEventListener('mouseleave', function () { show(false); });
    btn.parentNode.addEventListener('mouseleave', function (e) {
      if (panel.contains(e.relatedTarget)) return;
      setTimeout(function () { if (!panel.matches(':hover')) show(false); }, 120);
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.mega') || e.target.closest('.mega__panel')) return;
    $$('.mega__panel[data-open]').forEach(function (p) { open(p, false); });
    $$('.mega__top[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  });

  /* ------------------------------------------------ mobile drawer */
  var burger = $('.hdr__burger');
  if (burger) burger.addEventListener('click', function () { showOverlay($('.mdrawer')); });

  /* ------------------------------------------------ header search (Shopify predictive search) */
  var searchBtn = $('[data-search-toggle]'), searchBar = $('.searchbar');
  if (searchBtn && searchBar) {
    var form = $('#SiteSearchForm'), out = $('#SiteSearchResults'), input = $('#SiteSearch');
    searchBtn.addEventListener('click', function () {
      var on = !isOpen(searchBar); open(searchBar, on);
      searchBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on && input) input.focus();
    });
    var suggest = function (q) {
      var endpoint = url('predictive_search', '/search/suggest.json');
      return fetch(endpoint + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var res = data && data.resources && data.resources.results;
          if (!res) return [];
          return (res.products || []).concat(res.collections || []).slice(0, 8).map(function (it) {
            return { label: it.title, href: it.url };
          });
        })
        .catch(function () { return []; });
    };
    var timer = null;
    var run = function () {
      var raw = (input.value || '').trim();
      out.innerHTML = '';
      if (!raw) return;
      suggest(raw).then(function (hits) {
        out.innerHTML = '';
        if ((input.value || '').trim() !== raw) return;
        hits.forEach(function (it) {
          var a = document.createElement('a'); a.href = it.href; a.textContent = it.label; out.appendChild(a);
        });
        if (!hits.length) {
          var p = document.createElement('p');
          p.textContent = t('nothing_matched', 'Nothing matched') + ' “' + raw + '”.';
          out.appendChild(p);
        }
        var all = document.createElement('a');
        all.href = url('search', '/search') + '?q=' + encodeURIComponent(raw);
        all.textContent = t('search_for', 'Search for') + ' “' + raw + '”';
        all.style.fontWeight = '700';
        out.appendChild(all);
      });
    };
    if (form && input) {
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
      form.addEventListener('submit', function (e) {
        if (!(input.value || '').trim()) { e.preventDefault(); input.focus(); }
      });
    }
  }

  /* ------------------------------------------------ promo strip dismiss */
  var promoX = $('.promo__x');
  if (promoX) promoX.addEventListener('click', function () { promoX.closest('.promo').hidden = true; });

  /* ------------------------------------------------ the cart
     Shopify's AJAX cart when it answers; a local cart when it does not (the
     offline preview), so the drawer and the cart page behave the same either way. */
  var KEY = 'nearside-cart', memory = [], online = true;
  function readLocal() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return memory; } }
  function writeLocal(items) { memory = items; try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} }
  function fromShopify(cart) {
    return (cart.items || []).map(function (it) {
      return {
        id: it.variant_id || it.id, key: it.key, handle: it.handle, title: it.product_title || it.title,
        line: it.variant_title && it.variant_title !== 'Default Title' ? String(it.variant_title).replace(/ \/ /g, ' , ') : '',
        price: it.final_price != null ? it.final_price : it.price, img: it.image || it.featured_image && it.featured_image.url,
        url: it.url, qty: it.quantity,
      };
    });
  }
  function getCart() {
    if (!online) return Promise.resolve(readLocal());
    return fetch(url('cart', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('no cart'); return r.json(); })
      .then(function (c) { var items = fromShopify(c); writeLocal(items); return items; })
      .catch(function () { online = false; return readLocal(); });
  }
  function cartCount(items) { return items.reduce(function (n, it) { return n + it.qty; }, 0); }
  var badge = $('[data-cart-count]');
  function paintBadge(items) {
    if (badge) { var n = cartCount(items); badge.textContent = n; badge.hidden = n < 1; }
    var inCart = $('[data-in-cart]');
    if (inCart && product) {
      var v = currentVariant();
      inCart.textContent = items.filter(function (it) { return v && it.id === v[0]; }).reduce(function (a, it) { return a + it.qty; }, 0);
    }
  }

  var cart = $('.cart');
  function itemHTML(it, qtyText) {
    /* A line the shopper can actually change: − n + , where 0 removes it. */
    var stepper = it.key
      ? '<div class="cart__qty" data-line-key="' + escH(it.key) + '">' +
          '<button type="button" data-step="-1" aria-label="' + escH(t('decrease_quantity', 'Decrease quantity for') + ' ' + it.title) + '">\u2212</button>' +
          '<span data-cart-qty>' + qtyText + '</span>' +
          '<button type="button" data-step="1" aria-label="' + escH(t('increase_quantity', 'Increase quantity for') + ' ' + it.title) + '">+</button>' +
        '</div>' +
        '<button class="cart__rm" type="button" data-line-remove="' + escH(it.key) + '">' + escH(t('remove', 'Remove')) + '</button>'
      : '<span data-cart-qty>' + qtyText + '</span>';
    return '<div class="cart__item">' +
      (it.img ? '<img src="' + escH(it.img) + '" alt="' + escH(it.title) + '" width="88" height="88">' : '<span class="cart__noimg" aria-hidden="true"></span>') +
      '<div><h3><a href="' + escH(it.url) + '">' + escH(it.title) + '</a></h3>' +
      (it.line ? '<p class="cart__meta" data-variant-line>' + escH(it.line) + '</p>' : '') +
      '<p class="cart__price"><span data-cart-price>' + money(it.price) + '</span></p>' +
      '<div class="cart__ctl">' + stepper + '</div></div></div>';
  }
  function renderDrawer(mode, added, items) {
    if (!cart) return;
    var head = $('.cart__head h2', cart), body = $('.cart__body', cart);
    var more = $('[data-cart-details]', cart);
    if (!more) {
      more = document.createElement('a');
      more.className = 'linkmore';
      more.setAttribute('data-cart-details', '');
      more.style.justifySelf = 'center';
      more.textContent = t('view_full_details', 'View full details');
      more.hidden = true;
      var foot = $('.cart__foot', cart);
      if (foot) foot.appendChild(more);
    }
    if (mode === 'added' && added) {
      head.textContent = t('item_added', 'Item added to your cart');
      /* render the real cart lines, not just the added one, so each carries a
         line key and can be adjusted without leaving the drawer */
      body.innerHTML = (items && items.length)
        ? items.map(function (it) { return itemHTML(it, it.qty); }).join('')
        : itemHTML(added, added.addedQty);
      if (more) { more.hidden = false; more.href = added.url; }
    } else {
      head.textContent = t('your_cart', 'Your cart');
      body.innerHTML = items.length ? items.map(function (it) { return itemHTML(it, it.qty); }).join('') : '<p class="cart__empty">' + t('cart_empty', 'Your cart is empty') + '</p>';
      if (more) more.hidden = true;
    }
  }
  /* ---- drawer quantity: change the real Shopify cart, surface its refusals ---- */
  function drawerNote(msg) {
    if (!cart) return;
    var el = $('[data-cart-note]', cart);
    if (!el) {
      var body = $('.cart__body', cart); if (!body) return;
      el = document.createElement('p');
      el.className = 'cart__note';
      el.setAttribute('data-cart-note', '');
      el.setAttribute('role', 'status');
      body.parentNode.insertBefore(el, body);
    }
    el.textContent = msg || '';
    el.hidden = !msg;
  }
  function setDrawerQty(key, qty) {
    if (!online) return;
    fetch(url('cart_change', '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
    }).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (err) {
          drawerNote(err.description || err.message || '');
          return fetch(url('cart', '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (rr) { return rr.json(); });
        });
      }
      drawerNote('');
      return r.json();
    }).then(function (c) {
      var next = fromShopify(c);
      writeLocal(next); paintBadge(next); renderDrawer('cart', null, next);
    }).catch(function () { online = false; });
  }
  if (cart) {
    cart.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-line-remove]');
      if (rm) { e.preventDefault(); setDrawerQty(rm.getAttribute('data-line-remove'), 0); return; }
      var b = e.target.closest('[data-step]');
      if (!b) return;
      e.preventDefault();
      var box = b.closest('[data-line-key]'); if (!box) return;
      var now = parseInt(($('[data-cart-qty]', box) || {}).textContent, 10) || 0;
      setDrawerQty(box.getAttribute('data-line-key'), now + (+b.getAttribute('data-step')));
    });
  }

  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      getCart().then(function (items) { paintBadge(items); renderDrawer('cart', null, items); showOverlay(cart); });
    });
  });

  /* ------------------------------------------------ product: data + variant picker */
  var product = null;
  try { var pd = $('#ProductData'); if (pd) product = JSON.parse(pd.textContent); } catch (e) { product = null; }
  var gallerySelect = null;
  function selectedValues() {
    return $$('.opt').map(function (fs) { var s = $('input:checked', fs); return s ? (s.getAttribute('data-value') || s.value) : null; });
  }
  function currentVariant() {
    if (!product) return null;
    var vals = selectedValues();
    if (!product.hasOptions || !vals.length) return product.variants[0];
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i], ok = true;
      for (var k = 0; k < vals.length; k++) if (v[1][k] !== vals[k]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  var addBtn = $('[data-add-to-cart]'), addLabel = addBtn ? addBtn.textContent.trim() : t('add_to_cart', 'Add to cart');
  if (/sold out/i.test(addLabel)) addLabel = t('add_to_cart', 'Add to cart');
  var priceEl = $('[data-price]') || $('.pinfo .price'), variantOut = $('[data-variant-line]');
  function variantLine() {
    var parts = [];
    $$('.opt').forEach(function (fs) {
      var sel = $('input:checked', fs);
      if (sel) parts.push(fs.getAttribute('data-option') + ': ' + (sel.getAttribute('data-value') || sel.value));
    });
    return parts.join(' , ');
  }
  function markUnavailable() {
    if (!product || !product.hasOptions) return;
    var vals = selectedValues();
    $$('.opt').forEach(function (fs, k) {
      $$('input', fs).forEach(function (inp) {
        var val = inp.getAttribute('data-value') || inp.value;
        var ok = product.variants.some(function (v) {
          if (!v[4] || v[1][k] !== val) return false;
          for (var j = 0; j < k; j++) if (v[1][j] !== vals[j]) return false;
          return true;
        });
        inp.classList.toggle('is-unavail', !ok);
      });
    });
  }
  function syncVariant() {
    var line = variantLine();
    if (variantOut && line) variantOut.textContent = line;
    if (!product) return;
    markUnavailable();
    var v = currentVariant();
    var avail = !!(v && v[4]);
    if (priceEl && v) {
      var sale = v[3] && v[3] > v[2];
      priceEl.innerHTML = sale
        ? '<span class="vh">' + t('regular_price', 'Regular price') + '</span><s>' + money(v[3]) + '</s><span class="vh">' + t('sale_price', 'Sale price') + '</span><span class="sale">' + money(v[2]) + '</span>' + (avail ? '<span class="pflag">' + t('on_sale', 'Sale') + '</span>' : '<span class="pflag pflag--muted">' + t('sold_out', 'Sold out') + '</span>')
        : '<span class="vh">' + t('regular_price', 'Regular price') + '</span>' + money(v[2]) + (avail ? '' : '<span class="pflag pflag--muted">' + t('sold_out', 'Sold out') + '</span>');
    }
    if (addBtn) { addBtn.disabled = !avail; addBtn.textContent = v ? (avail ? addLabel : t('sold_out', 'Sold out')) : t('unavailable', 'Unavailable'); }
    $$('[data-buy-now]').forEach(function (a) { a.hidden = !avail; });
    var idInput = $('[data-variant-id]'); if (idInput && v) idInput.value = v[0];
    if (v && v[5] > -1 && gallerySelect) gallerySelect(v[5]);
    getCart().then(paintBadge);
  }
  $$('.opt input').forEach(function (r) { r.addEventListener('change', syncVariant); });

  function addCurrent() {
    var v = currentVariant();
    if (!product || !v || !v[4]) return Promise.resolve(null);
    var qty = Math.max(1, parseInt(($('#Quantity') || {}).value, 10) || 1);
    var added = { id: v[0], handle: product.handle, title: product.title, line: product.hasOptions ? variantLine() : '', price: v[2], img: product.img, url: product.url, qty: qty, addedQty: qty };
    var body = new URLSearchParams(); body.set('id', v[0]); body.set('quantity', qty);
    if (!online) return Promise.resolve(addLocal(added));
    return fetch(url('cart_add', '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: body.toString(),
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return added; })
      .catch(function () { online = false; return addLocal(added); });
  }
  function addLocal(added) {
    var items = readLocal();
    var found = items.filter(function (it) { return it.id === added.id; })[0];
    if (found) found.qty += added.qty; else items.push({ id: added.id, handle: added.handle, title: added.title, line: added.line, price: added.price, img: added.img, url: added.url, qty: added.qty });
    writeLocal(items);
    return added;
  }
  function addAndShow() {
    addCurrent().then(function (added) {
      if (!added) return;
      getCart().then(function (items) { paintBadge(items); renderDrawer('added', added, items); showOverlay(cart); });
    });
  }
  var productForm = $('#ProductForm') || $('[data-product-form]');
  if (productForm) productForm.addEventListener('submit', function (e) { e.preventDefault(); addAndShow(); });
  $$('[data-add-to-cart]').forEach(function (b) {
    if (b.form) return; /* handled by the form's submit */
    b.addEventListener('click', addAndShow);
  });
  $$('[data-buy-now]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (product) { e.preventDefault(); addCurrent().then(function () { window.location.href = a.getAttribute('href'); }); } });
  });

  /* ------------------------------------------------ hero slider */
  $$('[data-slider]').forEach(function (root) {
    var track = $('.hero__track', root), slides = $$('.hero__slide', track), i = 0;
    var dots = $$('.dots button', root);
    var go = function (n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      track.style.transition = 'transform .5s ease';
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    };
    $$('[data-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
    $$('[data-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(i + 1); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    go(0);
    var timer = setInterval(function () { go(i + 1); }, 6000);
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
  });

  /* ------------------------------------------------ product-row carousels */
  $$('[data-row]').forEach(function (root) {
    var rail = $('.prow', root);
    if (!rail) return;
    var cur = $('[data-row-current]', root), tot = $('[data-row-total]', root);
    var ctl = $('.rowfoot__ctl', root);
    var pages = function () { return Math.max(1, Math.ceil((rail.scrollWidth - 4) / rail.clientWidth)); };
    var render = function () {
      var total = pages();
      var max = rail.scrollWidth - rail.clientWidth;
      var p = max > 4 ? 1 + Math.round((rail.scrollLeft / max) * (total - 1)) : 1;
      if (cur) cur.textContent = Math.min(total, Math.max(1, p));
      if (tot) tot.textContent = total;
      if (ctl) ctl.hidden = total < 2;
    };
    $$('[data-prev]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var x = rail.scrollLeft - rail.clientWidth;
        rail.scrollTo({ left: x < 10 ? (rail.scrollLeft < 10 ? rail.scrollWidth : 0) : x, behavior: 'smooth' });
      });
    });
    $$('[data-next]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var x = rail.scrollLeft + rail.clientWidth;
        rail.scrollTo({ left: x > max - 10 ? (rail.scrollLeft > max - 10 ? 0 : max) : x, behavior: 'smooth' });
      });
    });
    rail.addEventListener('scroll', render);
    window.addEventListener('resize', render);
    render();
  });

  /* ------------------------------------------------ product gallery + lightbox */
  var stage = $('[data-stage]');
  if (stage) {
    var thumbs = $$('.gal__thumbs button');
    var select = function (k) {
      var thumb = thumbs[k]; if (!thumb) return;
      var img = $('img', thumb);
      // never show a thumbnail file on the stage: fall back to the same image at 1600px
      stage.src = img.getAttribute('data-full') || img.getAttribute('src').replace(/([?&])width=\d+/, '$1width=1600');
      stage.alt = img.alt;
      stage.setAttribute('data-index', k);
      thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === k ? 'true' : 'false'); });
    };
    gallerySelect = select;
    thumbs.forEach(function (thumb, k) { thumb.addEventListener('click', function () { select(k); }); });
    select(0);
    var modal = $('.modal'), modalImg = $('.modal img');
    var openModal = function () {
      if (!modal) return;
      modalImg.src = stage.getAttribute('src'); modalImg.alt = stage.alt;
      open(modal, true); document.body.style.overflow = 'hidden';
      $('.modal .xbtn').focus();
    };
    stage.parentNode.addEventListener('click', function (e) { if (!e.target.closest('[data-open-media]')) openModal(); });
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.closest('.xbtn')) { open(modal, false); document.body.style.overflow = ''; }
      });
    }
    $$('[data-open-media]').forEach(function (b, k) {
      b.addEventListener('click', function (e) { e.preventDefault(); select(k); openModal(); });
    });
  }
  if (product) markUnavailable();

  /* ------------------------------------------------ quantity stepper */
  var qtyInput = $('#Quantity');
  if (qtyInput) {
    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-qty'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
      });
    });
  }

  /* ------------------------------------------------ pickup drawer */
  $$('[data-pickup-open]').forEach(function (b) {
    b.addEventListener('click', function () { showOverlay($('.pdrawer')); });
  });

  /* ------------------------------------------------ store locator */
  var locator = $('.locator'), mapTab = $('.maptab');
  if (mapTab && locator) {
    var title = $('[data-locator-title]', locator);
    if (title) title.textContent = t('store_locations', 'Store Locations');
    mapTab.addEventListener('click', function () {
      var on = !isOpen(locator); open(locator, on);
      mapTab.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) {
        var m = $('[data-locator-map]', locator);
        var first = $('.locator__store p', locator);
        if (m) setTimeout(function () { m.textContent = first ? first.textContent.split('\n')[0] : ''; }, 400);
      }
    });
    var toggle = $('[data-locator-toggle]', locator);
    if (toggle) toggle.addEventListener('click', function () {
      var list = $('[data-locator-list]', locator);
      list.hidden = !list.hidden;
      toggle.setAttribute('aria-expanded', list.hidden ? 'false' : 'true');
    });
    var search = $('#storeSearchInput');
    if (search) search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase();
      $$('.locator__store', locator).forEach(function (item) {
        var hit = !q || item.textContent.toLowerCase().indexOf(q) > -1;
        item.style.display = hit ? '' : 'none';
      });
    });
    var close = $('[data-locator-close]', locator);
    /* keep the tab's aria-expanded in step with the panel, or a screen reader is
       told the locator is still open after it has been dismissed */
    if (close) close.addEventListener('click', function () {
      open(locator, false);
      if (mapTab) mapTab.setAttribute('aria-expanded', 'false');
    });
  }

  /* ------------------------------------------------ newsletter + contact → confirmation
     The forms are real Shopify forms; they are posted in the background so the
     confirmation can be shown in place, the way the design does it. */
  function noteFor(form) {
    var id = form.getAttribute('data-confirm');
    if (id) return document.getElementById(id);
    var sib = form.nextElementSibling;
    while (sib) { if (sib.classList && (sib.classList.contains('subnote') || sib.classList.contains('formnote'))) return sib; sib = sib.nextElementSibling; }
    return null;
  }
  $$('form.subscribe, form.form').forEach(function (form) {
    if (form.id === 'CartForm') return;
    form.addEventListener('submit', function (e) {
      var note = noteFor(form);
      if (!note) return;
      e.preventDefault();
      var action = form.getAttribute('action');
      var send = action ? fetch(action, { method: 'POST', body: new FormData(form) }).catch(function () {}) : Promise.resolve();
      var name = (form.querySelector('#ContactForm-name') || {}).value || '';
      var email = form.querySelector('input[type="email"]');
      send.then(function () {
        note.hidden = false;
        note.setAttribute('role', 'status');
        if (form.id === 'ContactForm') {
          note.textContent = t('thanks', 'Thanks') + (name ? ', ' + name.trim() : '') + ' — ' + t('contact_confirmation', 'your message is on its way.');
        } else {
          note.textContent = t('thanks', 'Thanks') + ' — ' + ((email && email.value) || 'you') + ' ' + t('newsletter_success', 'is on the list.');
        }
        form.reset();
        note.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });
  });

  /* ------------------------------------------------ cart page */
  var cartPage = $('#CartForm') || $('[data-cart-page]');
  if (cartPage) {
    var linesEl = $('[data-cart-lines]', cartPage), emptyEl = $('[data-cart-empty]', cartPage), sumEl = $('[data-cart-sum]', cartPage);
    var totalEl = $('[data-cart-total]', cartPage), noteEl = $('#CheckoutNote');
    var lineHTML = function (it, i) {
      return '<div class="cline">' +
        '<a href="' + escH(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.img ? '<img src="' + escH(it.img) + '" alt="" width="96" height="96">' : '<span class="cart__noimg"></span>') + '</a>' +
        '<div><h3><a href="' + escH(it.url) + '">' + escH(it.title) + '</a></h3>' + (it.line ? '<p class="cline__meta">' + escH(it.line) + '</p>' : '') + '<p class="cline__unit">' + money(it.price) + '</p></div>' +
        '<div class="cline__ctl"><div class="qty"><button type="button" data-line="' + i + '" data-step="-1"><span aria-hidden="true">−</span><span class="vh">' + t('decrease_quantity', 'Decrease quantity for') + ' ' + escH(it.title) + '</span></button>' +
        '<label class="vh" for="Line-' + i + '">' + t('quantity_for', 'Quantity for') + ' ' + escH(it.title) + '</label><input id="Line-' + i + '" type="number" name="updates[]" min="0" value="' + it.qty + '" data-line="' + i + '" inputmode="numeric">' +
        '<button type="button" data-line="' + i + '" data-step="1"><span aria-hidden="true">+</span><span class="vh">' + t('increase_quantity', 'Increase quantity for') + ' ' + escH(it.title) + '</span></button></div>' +
        '<button class="cline__rm" type="button" data-remove="' + i + '">' + t('remove', 'Remove') + '</button></div>' +
        '<p class="cline__price">' + money(it.price * it.qty) + '</p></div>';
    };
    var paintCartPage = function (items) {
      emptyEl.hidden = items.length > 0; sumEl.hidden = !items.length;
      linesEl.innerHTML = items.map(lineHTML).join('');
      totalEl.textContent = money(items.reduce(function (s, it) { return s + it.price * it.qty; }, 0));
      paintBadge(items);
    };
    var cartNote = function (msg) {
      var el = document.querySelector('[data-cart-note]');
      if (!el) {
        var host = document.querySelector('[data-cart-lines]');
        if (!host) return;
        el = document.createElement('p');
        el.className = 'cart__note';
        el.setAttribute('data-cart-note', '');
        el.setAttribute('role', 'status');
        host.parentNode.insertBefore(el, host);
      }
      el.textContent = msg || '';
      el.hidden = !msg;
    };
    var setQty = function (i, q) {
      var items = readLocal();
      if (!items[i]) return;
      var line = i + 1;
      if (!online) {
        if (q < 1) items.splice(i, 1); else items[i].qty = q;
        writeLocal(items); paintCartPage(items); return;
      }
      fetch(url('cart_change', '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, q) }),
      }).then(function (r) {
        /* Shopify answered. A 4xx is a real answer (stock limits), not an outage:
           surface its message and re-sync from the server so the page never shows
           a quantity or total the cart does not actually hold. */
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (err) {
            cartNote(err.description || err.message || '');
            return fetch(url('cart', '/cart') + '.js', { headers: { Accept: 'application/json' } })
              .then(function (rr) { return rr.json(); });
          });
        }
        cartNote('');
        return r.json();
      })
        .then(function (c) { var next = fromShopify(c); writeLocal(next); paintCartPage(next); })
        .catch(function () {
          /* only a genuine network failure reaches here */
          online = false;
          if (q < 1) items.splice(i, 1); else items[i].qty = q;
          writeLocal(items); paintCartPage(items);
        });
    };
    linesEl.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-remove')) { e.preventDefault(); setQty(+b.getAttribute('data-remove'), 0); return; }
      if (b.hasAttribute('data-step')) { e.preventDefault(); var i = +b.getAttribute('data-line'); setQty(i, (readLocal()[i] || { qty: 1 }).qty + (+b.getAttribute('data-step'))); }
    });
    linesEl.addEventListener('change', function (e) { var inp = e.target.closest('input[data-line]'); if (inp) setQty(+inp.getAttribute('data-line'), parseInt(inp.value, 10) || 0); });
    cartPage.addEventListener('submit', function (e) {
      if (online) return; /* a real store checks out on the server */
      e.preventDefault();
      var items = readLocal(); if (!items.length) return;
      var n = cartCount(items), total = money(items.reduce(function (s, it) { return s + it.price * it.qty; }, 0));
      writeLocal([]); linesEl.innerHTML = '';
      $$('.cartsum__total, .cartsum > p:not(.formnote), .cartsum button', cartPage).forEach(function (el) { el.hidden = true; });
      noteEl.hidden = false; noteEl.setAttribute('role', 'status');
      noteEl.textContent = t('order_received', 'Thanks — your order for') + ' ' + n + (n === 1 ? ' item' : ' items') + ' (' + total + ') ' + t('order_received_tail', 'has been received.');
      noteEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    getCart().then(function (items) { if (items.length || !online) paintCartPage(items); else paintBadge(items); });
    if (location.hash === '#checkout' && sumEl && !sumEl.hidden) { var cb = $('button[name="checkout"]', cartPage); if (cb) { sumEl.scrollIntoView({ block: 'center' }); cb.focus(); } }
  }

  /* ------------------------------------------------ collection filter + sort */
  $$('[data-collection]').forEach(function (root) {
    var grid = $('[data-grid]', root), cards = $$('.card', grid), sortSel = $('[data-sort]', root);
    var count = $('[data-count]', root), empty = $('[data-empty]', root);
    var apply = function () {
      var fin = $('[data-filter="in"]', root), fout = $('[data-filter="out"]', root);
      var wantIn = fin && fin.checked, wantOut = fout && fout.checked;
      var mode = sortSel ? sortSel.value : 'manual';
      var list = cards.slice().sort(function (a, b) {
        var d = a.dataset;
        switch (mode) {
          case 'title-ascending': return d.title.localeCompare(b.dataset.title);
          case 'title-descending': return b.dataset.title.localeCompare(d.title);
          case 'price-ascending': return d.price - b.dataset.price;
          case 'price-descending': return b.dataset.price - d.price;
          case 'created-ascending': return d.date.localeCompare(b.dataset.date);
          case 'created-descending': return b.dataset.date.localeCompare(d.date);
          default: return d.i - b.dataset.i;
        }
      });
      var shown = 0;
      list.forEach(function (c) {
        var av = c.dataset.avail === '1';
        var vis = (!wantIn && !wantOut) || (wantIn && av) || (wantOut && !av);
        c.hidden = !vis; if (vis) shown++;
        grid.appendChild(c);
      });
      if (count) { count.textContent = shown; count.nextSibling.textContent = shown === 1 ? ' ' + t('product_one', 'product') : ' ' + t('product_other', 'products'); }
      if (empty) empty.hidden = shown > 0;
    };
    $$('[data-filter]', root).forEach(function (f) { f.addEventListener('change', apply); });
    /* When the section renders Shopify's own facets, sorting and filtering must go to
       the server: the page only holds one page of the collection, so sorting or
       filtering the cards in front of us would silently ignore every other page. */
    var facets = $('[data-facets]', root);
    var go = function (params) {
      var u = new URL(window.location.href);
      u.searchParams.delete('page');
      params.forEach(function (kv) {
        u.searchParams.delete(kv[0]);
      });
      params.forEach(function (kv) {
        if (kv[1] !== null && kv[1] !== '') u.searchParams.append(kv[0], kv[1]);
      });
      window.location.assign(u.toString());
    };
    if (sortSel && sortSel.hasAttribute('data-sort-server')) {
      sortSel.addEventListener('change', function () { go([['sort_by', sortSel.value]]); });
    } else if (sortSel) {
      sortSel.addEventListener('change', apply);
    }
    if (facets) {
      facets.addEventListener('change', function () {
        var boxes = $$('input[type=checkbox]', facets);
        var params = [['filter.v.availability', null]];
        boxes.forEach(function (b) { if (b.checked) params.push([b.name, b.value]); });
        go(params);
      });
    }
  });

  getCart().then(paintBadge);
})();
